import React, { FC } from 'react';
import {
	BIDDER_CUMMULATIVE_DISPLAY_BACKGROUND_COLORS,
	BIDDER_CUMMULATIVE_DISPLAY_TEXT_COLORS,
} from '../../constants/BidderStatuses';

const CummulativeBidderStatusDisplay: FC<any> = ({ status }): React.ReactElement => {
	if (!status) {
		return null;
	}

	const statusColor = BIDDER_CUMMULATIVE_DISPLAY_TEXT_COLORS[status];
	const statusBackgroundColor = BIDDER_CUMMULATIVE_DISPLAY_BACKGROUND_COLORS[status];

	return (
		<span
			style={{
				color: statusColor,
				background: statusBackgroundColor,
				padding: '4px 12px',
				borderRadius: 16,
				whiteSpace: 'nowrap',
			}}
		>
			{status}
		</span>
	);
};

export default CummulativeBidderStatusDisplay;
